import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeSalutationCreate,
  detail: routeSalutationDetail,
  home: routeSalutationSettingsHome,
  root: routeSalutationSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-salutation',
  createPath: 'new-salutation',
  detailName: 'salutation-detail',
  doctype: DOCTYPES.SALUTATION,
  homeName: 'salutation',
  path: 'salutation',
  views: {
    create: async () => await import('@/components/viewsExternal/salutation/AddSalutation.vue'),
    detail: async () => await import('@/components/viewsExternal/salutation/ViewSalutation.vue'),
    list: async () => await import('@/components/viewsExternal/settings/brm/ViewBRMSettings.vue'),
  },
})

export {
  routeSalutationCreate,
  routeSalutationDetail,
  routeSalutationSettingsHome,
  routeSalutationSettingsRoot,
}
